<template>
  <div class="pb-15">
    <div class="d-flex justify-space-between">
      <div class="card-big-title mt-5 mb-5">My Content</div>
      <div class="gap1">
        <v-menu
          v-if="!isEmpty"
          v-model="isHelpMenuOpen"
          offset-y
          :close-on-content-click="false"
        >
          <template v-slot:activator="{ on, attrs }">
            <a
              v-bind="attrs"
              v-on="on"
              href="#"
              class="d-flex gap4 align-center"
              style="color: var(--v-profileAnchorColor-base); font-weight: 700;"
            ><i class="material-icons-outlined" style="transform: rotate(180deg);">tungsten</i> Help me choose keywords</a>
          </template>
          <v-list>
            <v-list-item-content
              class="pl-6 pr-6"
              style="max-width: 350px;"
            >
              <help-with-keywords-form
                @close="isHelpMenuOpen = false"
              />
            </v-list-item-content>
          </v-list>
        </v-menu>

        <v-btn
          v-if="!isEmpty"
          @click="gotoInsight"
          rounded
          color="profileAnchorColor"
          class="text-none whiteColor--text font16 padding8 height38"
          tag="a"
        >
          Order content
        </v-btn>
      </div>
    </div>

    <div v-if="isEmpty" class="silo-container-empty mb-5">
      <div class="silo-structure-empty-container">
        <img src="/static/quick-content-orders.svg" class="silo-structure" />
      </div>
      <div class="silo-text-empty-container">

        <img src="/static/white_glove_label.png" style="width:170px;" />

        <div class="step-title">Quick content order</div>
        <div class="title-text">
          Skip silo setup and get content written fast. Click the button below to jump into Keyword insight and select keywords for us to write content for. You can also choose keywords from the Keyword Strategy tab - both work just as well.
        </div>
        <div class="gap1">
          <v-btn
            @click="gotoInsight"
            rounded
            color="profileAnchorColor"
            class="text-none whiteColor--text font16 padding8 height38"
            tag="a"
          >
            Select keywords
          </v-btn>
          <v-menu
            v-model="isHelpMenuOpen"
            offset-y
            :close-on-content-click="false"
          >
            <template v-slot:activator="{ on, attrs }">
              <a
                v-bind="attrs"
                v-on="on"
                href="#"
                class="d-flex gap4 align-center"
                style="color: var(--v-mainColor-base); font-weight: 700;"
              ><i class="material-icons-outlined" style="transform: rotate(180deg);">tungsten</i> Help me choose keywords</a>
            </template>
            <v-list>
              <v-list-item-content
                class="pl-6 pr-6"
                style="max-width: 350px;"
              >
                <help-with-keywords-form
                  @close="isHelpMenuOpen = false"
                />
              </v-list-item-content>
            </v-list>
          </v-menu>
        </div>
      </div>
    </div>

    <section v-if="!isEmpty">
      <div v-if="isWhiteGloveUser" class="sites-or-pages-container silos-container silos-container-white-glove mt-6">
        <div>
          <div class="white-glove-order-label mainColor--text mb-6">
            <v-checkbox 
              v-if="inCartSilos.length"
              hide-details="auto" 
              dense
              class="silo-checkbox"
              style="margin-top: 0px !important;"
              color="#007aff"
              :value="selectedSiloIds.length === inCartSilos.length" 
              @click.stop="selectedSiloIds = selectedSiloIds.length === inCartSilos.length ? [] : inCartSilos.map(silo => silo.id)"
            >
            </v-checkbox>
            <i class="material-icons" style="color:#8439FF;">circle</i>
            <div class="type">In cart</div>
            <div class="count">{{ inCartSilos.length }}</div>
          </div>
          <order-card
            v-for="(silo, idx) in inCartSilos"
            :key="idx"
            :silo="silo"
            :refreshData="() => fetchSilos()"
            :isSelected="selectedSiloIds.includes(silo.id)"
            @toggleSelected="selectedSiloIds = selectedSiloIds.includes(silo.id) ? selectedSiloIds.filter(id => id !== silo.id) : [...selectedSiloIds, silo.id]"
          />
        </div>
        <div>
          <div class="white-glove-order-label mainColor--text mb-6">
            <i class="material-icons" style="color:#F69C40;">circle</i>
            <div class="type">Ordered</div>
            <div class="count">{{ orderedPendingSilos.length }}</div>
          </div>
          <order-card
            v-for="(silo, idx) in orderedPendingSilos"
            :key="idx"
            :silo="silo"
            :refreshData="() => fetchSilos()"
          />
        </div>
        <div>
          <div class="white-glove-order-label mainColor--text mb-6">
            <i class="material-icons" style="color:#EF34A4;">circle</i>
            <div class="type">In progress</div>
            <div class="count">{{ orderedInProgressSilos.length }}</div>
          </div>
          <order-card
            v-for="(silo, idx) in orderedInProgressSilos"
            :key="idx"
            :silo="silo"
            :refreshData="() => fetchSilos()"
          />
        </div>
        <div>
          <div class="white-glove-order-label mainColor--text mb-6">
            <i class="material-icons" style="color:#1AB26A;">circle</i>
            <div class="type">Completed</div>
            <div class="count">{{ orderedCompletedSilos.length }}</div>
          </div>
          <order-card
            v-for="(silo, idx) in orderedCompletedSilos"
            :key="idx"
            :silo="silo"
            :refreshData="() => fetchSilos()"
          />
        </div>
      </div>
      <div v-else class="sites-or-pages-container silos-container mt-6">
        <order-card
          v-for="(silo, idx) in silos"
          :key="idx"
          :silo="silo"
          :refreshData="() => fetchSilos()"
        />
      </div>
    </section>

    <div
      class="flex white-selected-box h78 justify-space-between mt-4"
      v-if="selectedSiloIds?.length"
    >
      <div class="box-primary-bg d-flex align-center">
        <div class="count-value px-5">
          {{ selectedSiloIds?.length || 0 }}
        </div>
      </div>
      <div class="px-3 d-flex align-center">
        <div class="selected-text">item{{ selectedSiloIds?.length === 1 ? '':'s'}} selected</div>
      </div>
      <div class="d-flex flex-wrap align-center">
        <div class="flex gap15 align-center fill-height">
          <span
            class="flex flex-column align-center cursor-pointer"
            @click="goToCheckoutForSelectedSilos()"
          >
            <img class="quick-content-icon" src="/static/quick_content_icon_orange.svg" style="width:28px; height:28px;" />
            <div class="action-title">Order content</div>
          </span>
          <span
            class="flex flex-column align-center cursor-pointer w78"
            @click="showDeleteConfirmModal = true"
          >
            <i class="material-icons-outlined orange-color">delete</i>
            <div class="action-title">Delete</div>
          </span>
          <div
            class="cross-container flex justify-center align-center fill-height px-5"
          >
            <i @click="selectedSiloIds = []" class="material-icons cursor-pointer">close</i>
          </div>
        </div>
      </div>
    </div>

    <div
      v-if="isSubAccountRelationSelected"
      class="modal"
      :class="{ 'is-active': showSubAccountNotAllowedToBuyModal }"
    >
      <div
        class="modal-background"
        @click="showSubAccountNotAllowedToBuyModal = false"
      ></div>
      <div class="modal-content">
        <div class="box modal-container">
          <div class="modal-content-root">
            <div class="subtitle-font mainColor--text mb-3" style="font-size: 1.2rem; font-weight: 700;">
              You can’t place orders
            </div>
            <div class="subtitle-font mainColor--text mb-5" style="line-height: 1.5;">
              Only the main account has permission to create orders. Please contact your account admin ({{ selectedSubAccountRelation.agencyUserEmail }}) if you need help.
            </div>
            <div class="text-right">
              <v-btn
                rounded
                color="profileAnchorColor"
                class="button-with-icon whiteColor--text text-none"
                @click="showSubAccountNotAllowedToBuyModal = false"
              >
                Ok
              </v-btn>
            </div>
          </div>
        </div>
      </div>
      <button class="custom-modal-close-btn" aria-label="close" @click="showSubAccountNotAllowedToBuyModal = false"><i class="material-icons" style="font-size: 1.7rem;">close</i></button>
    </div>

    <div class="modal" :class="{ 'is-active': !!showDeleteConfirmModal }">
      <div class="modal-background" @click.stop="showDeleteConfirmModal = false"></div>
      <div class="modal-content">
        <div class="box modal-container" style="overflow: hidden">
          <div class="modal-content-root">
            <div class="title-font is-size-4 mainColor--text">
              You’re about to delete multiple orders
            </div>
            <div class="control flex mt20">
              <div class="flex-grow-1"></div>
              <v-btn
                rounded
                outlined
                color="mainColor"
                class="button-with-icon mainColor--text text-none"
                @click.stop="showDeleteConfirmModal = false"
              >
                <span>Cancel</span>
              </v-btn>
              <v-btn
                rounded
                color="profileAnchorColor"
                class="button-with-icon text-none whiteColor--text"
                @click.stop="deleteSelectedSilos"
              >
                <i class="fa fa-trash mr5"></i>
                <span>Delete</span>
              </v-btn>
            </div>
          </div>
        </div>
        <button
          class="custom-modal-close-btn"
          aria-label="close"
          @click.stop="showDeleteConfirmModal = false"
        >
          <i class="material-icons">close</i>
        </button>
      </div>
    </div>

  </div>
</template>

<script>
import { getPureServicePkgName } from '@/utils';
import OrderCard from './OrderCard.vue';
import {
  whiteGlovePlans,
} from "@/components/plans_constants"
import HelpWithKeywordsForm from './HelpWithKeywordsForm.vue';
import { isEmpty } from 'lodash';

export default {
  components: { OrderCard, HelpWithKeywordsForm },
  props: ['campaignId'],
  data() {
    return {
      silos: [],
      isHelpMenuOpen: false,
      selectedSiloIds: [],
      showSubAccountNotAllowedToBuyModal: false,
      showDeleteConfirmModal: false,
    };
  },
  watch: {
    '$store.state.refreshDataAfterCartPurchase': function () {
      this.fetchSilos();
    }
  },
  computed: {
    user() {
      return this.$store.state.user
    },
    selectedSubAccountRelation() {
      return this.$store.state.selectedSubAccountRelation;
    },
    isSubAccountRelationSelected() {
      return !!this.$store.state.selectedSubAccountRelation;
    },
    isWhiteGloveUser () {
      if (!this.user) return false;

      const accountType = this.$store.state.selectedSubAccountRelation
        ?this.$store.state.selectedSubAccountRelation.ownerAccountType
        :this.user.accountType

      if (whiteGlovePlans.includes(getPureServicePkgName(accountType))) {
        return true;
      }
      return false;
    },
    isEmpty() {
      return !this.silos?.length;
    },
    site () {
      return this.$store.getters.siteById(parseInt(this.$route.params.siteId)) || {};
    },
    siteId () {
      return parseInt(this.$route.params.siteId);
    },
    orderedSilos () {
      return this.silos.filter((silo) => ['paid', 'to_be_paid_by_invoice'].includes(silo?.content_report_order?.order_status));
    },
    orderedPendingSilos () {
      return this.orderedSilos.filter((silo) => silo?.content_report_order?.fulfillement_status === 'pending');
    },
    orderedInProgressSilos () {
      return this.orderedSilos.filter((silo) => silo?.content_report_order?.fulfillement_status === 'in_progress');
    },
    orderedCompletedSilos () {
      let result = this.orderedSilos.filter((silo) => silo?.content_report_order?.fulfillement_status === 'completed')
      result.sort((a, b) => {
        return new Date(b?.content_report_order?.completed_at || '2000-01-01') - new Date(a?.content_report_order?.completed_at || '2000-01-01')
      })
      return result;
    },
    inCartSilos () {
      return this.silos.filter((silo) => ['in_cart'].includes(silo?.content_report_order?.order_status));
    },
    notOrderedSilos () {
      return this.silos.filter((silo) => !this.orderedSilos.includes(silo));
    },
  },
  methods: {
    gotoInsight() {
      const { siteId } = this.$route.params;
      this.$router.push(
        `/sites/${siteId}/campaign/${this.campaignId}/keyword-insight?fromQuickContentOrdersTab=1`,
      );
    },
    fetchSilos() {
      this.$store.commit('showLoading');
      this.$store
        .dispatch('getSilos', {
          campaignId: this.campaignId,
          paginate: 0,
          isForQuickContentOrder: 1,
          includeKeywords: 1,
          includeAiAndPageRunResult: 0,
          includeGuardDiffData: 0,
          includePage: 0,
        })
        .then((response) => {
          this.silos = response.data.data;
        })
        .finally(() => {
          this.$store.commit('hideLoading');
        });
    },
    closeTutorialBox() {
      const updatedSettings = {
        ...this.user.settings,
        hideSiloTutorialBox: true
      }

      // eager update of settings state
      this.$store.commit('setUserSettings', updatedSettings)

      // persist in backend
      this.$store.dispatch('updateUserSettings', updatedSettings)
    },
    goToCheckoutForSelectedSilos() {
      if (this.isSubAccountRelationSelected) {
        this.showSubAccountNotAllowedToBuyModal = true
        return
      }

      this.$store.commit('showLoading');
      this.$store.dispatch('createStripePayment', {
        packageType: 'CART_PURCHASE',
        userID: this?.selectedSubAccountRelation?.ownerId || this.user.id,
        items: this.inCartSilos.filter(silo => this.selectedSiloIds.includes(silo.id)).map(silo => ({
          'type': 'quick_content_order',
          'id': silo.content_report_order.id
        }))
      })
      .then((response) => {
        window.open(response.data.url, '_self')
      })
      .finally(() => {
        this.$store.commit('hideLoading');
      })
    },
    deleteSelectedSilos() {
      this.$store.commit('showLoading');
      this.$store
        .dispatch('bulkDeleteSilos', {
          body: {
            ids: this.selectedSiloIds
          }
        })
        .then(() => {
          this.$notify({
            group: 'info',
            type: 'success',
            text: 'Successfully deleted orders.',
          });
          this.selectedSiloIds = [];
          this.showDeleteConfirmModal = false;
          this.fetchSilos();
        });
    }
  },
  mounted() {
    this.fetchSilos();
  },
};

</script>

<style lang="scss" scoped>
@import './orders.scss';

.white-glove-order-label {
  display: flex;
  flex-direction: row;
  gap: 8px;
  align-items: center;

  .type {
    font-size: 16px;
    font-weight: 700;
    line-height: 13.86px;
  }

  .count {
    padding: 3px 10px;
    background: #fff;
    border: 1px solid #c7c7c7;
    border-radius: 12px;
    font-weight: 700;
  }
}

::v-deep {
  .silo-checkbox {
    padding: 0;
    .v-input__slot, .v-input--selection-controls__input {
      margin: 0 !important;
      padding: 0 !important;
    }
  }
}
</style>
